import {MONTH_FORMAT} from 'consts'
import moment from 'moment'

export const getMonth = (date?: string) => {
  return moment(date).format(MONTH_FORMAT)
}
